import React, { useEffect, useState } from "react";
import Head from "next/head";
import getMetaTagData from "../../src/common/services/getMetaTagData";
import MainTop from "../../src/component/m/maintop/MainTop";
import axios from "axios";
import moment from "moment";
import MainBottom from "../../src/component/m/MainBottom/MainBottom";

function Home({ metaTagData, jWTCheck }) {
  // 좌우 슬라이더 1 번째 대표 프로그램 bestProgram
  const [bestProgramMaxPageCount, setBestProgramMaxPageCount] = useState(0);
  const [bestProgram, setBestProgram] = useState(0);
  const [bestProgramData, setBestProgramData] = useState([]);
  const [bestProgramViewData, setBestProgramViewData] = useState([]);
  const bestProgramItemsPerPage = 6;

  // 좌우 슬라이더 2 번째 최신 소식 recentNews
  const [recentNewsMaxPageCount, setRecentNewsMaxPageCount] = useState(0);
  const [recentNews, setRecentNews] = useState(0);
  const [recentNewsData, setRecentNewsData] = useState([]);
  const [recentNewsViewData, setRecentNewsViewData] = useState([]);
  const recentNewsItemsPerPage = 3;

  const [ScrollY, setScrollY] = useState(0);
  const handleFollow = () => {
    setScrollY(window.pageYOffset);
  };

  const [isIOS, setIsIOS] = useState(false); // ios check

  function deviceModel() {
    let currentOS;
    const mobile = /iphone|ipad|ipod|android/i.test(
      navigator.userAgent.toLowerCase()
    );
    if (mobile) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1) {
        currentOS = "android"; // 안드로이드 os 버젼 체크
        const deviceAgent =
          "Mozilla/5.0 (Linux; U; Android 2.2.1; en-us; device Build/FRG83) AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Safari/533.1";
        const androidversion = parseFloat(
          deviceAgent.match(/Android\s+([\d\.]+)/)[1]
        );
        document
          .querySelector("body")
          .getAttribute("data-device", androidversion);
        setIsIOS(false);
      } else if (
        userAgent.search("iphone") > -1 ||
        userAgent.search("ipod") > -1 ||
        userAgent.search("ipad") > -1 ||
        navigator.userAgent.match(/like Mac OS X/i) === true
      ) {
        currentOS = "ios";
        setIsIOS(true);
      } else {
        currentOS = "else";
        setIsIOS(false);
      }
    } else {
      currentOS = "nomobile";
      const ua = window.navigator.userAgent;
      if (ua.indexOf("Safari") > 0) {
        // iPad 접속 OS13부터 Macintosh으로 인식
        if (navigator.maxTouchPoints > 0) {
          setIsIOS(true);
        }
      }
    }
    return currentOS;
  }

  useEffect(() => {
    const wrapElement = document.getElementById("wrap");
    if (wrapElement) {
      // 요소 존재 확인
      if (ScrollY > 10) {
        wrapElement.className = "sbsabout_wrap";
      } else {
        wrapElement.className = "sbsabout_wrap gnb_main";
      }
    }
    deviceModel();
  }, [ScrollY]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener("scroll", handleFollow);
    };
    watch();
    return () => {
      window.removeEventListener("scroll", handleFollow);
    };
  }, []);

  const sectionStyle = {
    paddingleft: "0px",
    transform: "translate3d(0px, 0px, 0px)",
    transition: "all 0.3s ease-in-out 0s",
  };

  useEffect(() => {
    const config = {
      method: "get",
      url: "https://static.cloud.sbs.co.kr/recommend/sbs_programs/main.json",
      timeout: 3000,
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];
        const pageCount = parseInt(
          response.data.list.length / bestProgramItemsPerPage
        );
        setBestProgramMaxPageCount(pageCount);

        for (let i = 0; i < response.data.list.length; i++) {
          const element = response.data.list[i];
          const item = {
            title: element.title,
            img_url: element.img_url,
            link_url: element.link_url,
          };

          if (i < bestProgramItemsPerPage) {
            addList1.push(item);
          }
          addList.push(item);
        }
        setBestProgramData(addList);
        setBestProgramViewData(addList1);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  }, []);

  // https://api.board.sbs.co.kr/bbs/V2.0/basic/board/lists?callback=boardListCallback_sbspr_04&offset=0&limit=16&action_type=callback&board_code=sbspr_04&jwt-token=&_=1649656491700
  // 좌우 슬라이더 1 번째 대표 프로그램 bestProgram

  let start_X = 0;
  let end_X = 0;
  const posterTouch = (e) => {
    if (start_X === 0) {
      start_X = e.changedTouches[0].clientX;
      end_X = 0; // 드래그 시작 시 end_X 초기화
    } else {
      end_X = e.changedTouches[0].clientX;
    }

    // changedTouches는 배열이므로, 터치가 계속될 때 end_X만 업데이트
    // 터치가 끝났을 때 (onTouchEnd 이벤트에서) 페이지 변경 로직 실행하는 것이 더 일반적
    // 현재 onTouchMove에서 처리하므로, 드래그 중에 페이지가 변경될 수 있음
    if (start_X !== 0 && end_X !== 0) {
      const result = start_X - end_X;
      const sensitivity = 50; // 스와이프 민감도 (픽셀 단위)

      if (Math.abs(result) > sensitivity) {
        // 일정 거리 이상 움직였을 때만
        if (result > 0) {
          // 오른쪽으로 스와이프 (다음 페이지)
          setBestProgram((prev) => (prev + 1) % bestProgramMaxPageCount); // 순환하도록 변경
        } else {
          // 왼쪽으로 스와이프 (이전 페이지)
          setBestProgram(
            (prev) =>
              (prev - 1 + bestProgramMaxPageCount) % bestProgramMaxPageCount
          ); // 순환하도록 변경
        }
        // 페이지 변경 후 초기화
        start_X = 0;
        end_X = 0;
      }
    }
  };

  // 대표 프로그램 페이지 변경 시 데이터 업데이트
  useEffect(() => {
    const startIndex = bestProgram * bestProgramItemsPerPage;
    const endIndex = startIndex + bestProgramItemsPerPage;
    const addList = bestProgramData.slice(startIndex, endIndex);
    setBestProgramViewData(addList);
  }, [bestProgram, bestProgramData, bestProgramItemsPerPage]);

  // 대표 프로그램 이전/다음 버튼 핸들러 (순환 로직)
  const handlePrevBestProgram = () => {
    if (bestProgramMaxPageCount > 0) {
      setBestProgram(
        (prev) => (prev - 1 + bestProgramMaxPageCount) % bestProgramMaxPageCount
      );
    }
  };

  const handleNextBestProgram = () => {
    if (bestProgramMaxPageCount > 0) {
      setBestProgram((prev) => (prev + 1) % bestProgramMaxPageCount);
    }
  };

  useEffect(() => {
    const config = {
      method: "get",
      url: "https://api.board.sbs.co.kr/bbs/V2.0/basic/board/photo/main?callback=boardListCallback_sbspr_01&offset=0&limit=16&action_type=json&menuid=65947",
      timeout: 3000,
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];
        const pageCount = parseInt(response.data.length / recentNewsItemsPerPage);
        setRecentNewsMaxPageCount(pageCount);

        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          let img = element.IMG_URL;
          img = img ? img.replace(".jpg", "-cr.jpg") : null;
          const item = {
            title: element.TITLE,
            reg_date: element.REG_DATE,
            img_url: img,
            link_url: element.LINK_URL,
          };

          if (i < recentNewsItemsPerPage) {
            addList1.push(item);
          }
          addList.push(item);
        }
        setRecentNewsData(addList);
        setRecentNewsViewData(addList1);
      })
      .catch(function (error) {
        console.error("Error fetching recent news data:", error);
      })
      .finally(() => {});
  }, []);

  useEffect(() => {
    if (recentNews >= recentNewsMaxPageCount && recentNewsMaxPageCount > 0) {
      setRecentNews(0);
    } else if (recentNews < 0) {
      setRecentNews(recentNewsMaxPageCount - 1);
    }

    // 현재 페이지에 맞는 데이터 슬라이싱
    const startIndex = recentNews * recentNewsItemsPerPage;
    const endIndex = startIndex + recentNewsItemsPerPage;
    const addList = recentNewsData.slice(startIndex, endIndex);

    setRecentNewsViewData(addList);
  }, [recentNews, recentNewsData, recentNewsMaxPageCount]);

  // 이전/다음 버튼 핸들러
  const handlePrevNews = () => {
    setRecentNews((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const handleNextNews = () => {
    setRecentNews((prev) =>
      prev < recentNewsMaxPageCount - 1 ? prev + 1 : prev
    );
  };

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "UA-104756746-1");
      gtag("config", "G-L9E7Y63ZNE");
    }
  }, []);

  return (
    <>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=UA-104756746-1"
      />
      <Head>
        <link
          rel="stylesheet"
          href={process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL}
        />
        <meta
          name="viewport"
          content="user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width"
        />
        <meta
          name="description"
          content="SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!"
        />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={"" || ""} />
        <meta
          property="og:description"
          content={
            "SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!" ||
            ""
          }
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ""} />
        <meta property="og:url" content={metaTagData.currentUrl || ""} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={"" || ""} />
        <meta
          name="nate:description"
          content={
            "SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!" ||
            ""
          }
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ""} />
        <meta name="nate:url" content={metaTagData.currentUrl || ""} />
        <title>메인 - SBS 소개 : SBS</title>
      </Head>

      <ul id="skip_nav">
        <li>
          <a href="#container">본문컨텐츠</a>
        </li>
        <li>
          <a href="#footer">푸터 바로가기</a>
        </li>
      </ul>
      <div id="wrap" className="sbsabout_wrap section_main">
        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        <div id="container" className="contents">
          <h2 className="hide">SBS</h2>
          {/* <!-- 컨텐츠 --> */}
          <div className="sbsabout_main_w">
            <div className="sbsabout_main_visual_w">
              <h3 className="sbsabout_main_vtitle">
                SBS는 지난 30년간
                <br />
                대한민국의 방송 콘텐츠
                <br /> 산업을 이끌어 왔습니다.
              </h3>
            </div>
            <div className="sbsabout_main_inner">
              <div className="sbsabout_main_cont01">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    시대가 빠르게 변하고 <br />
                    모두가 위기를 이야기할 때,
                    <br />
                    SBS는 틀을 깨는 새로움으로 <br />
                    시청자에게 기쁨 주고 사랑을 받았습니다.
                  </p>
                </div>
              </div>

              <div className="sbsabout_main_cont02">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    SBS 예능은 상상의 경계를 <br />
                    뛰어넘는 새로운 콘텐츠와 <br />
                    실험적인 도전으로
                    <br />
                    웃음과 감동을 전합니다.
                  </p>
                </div>
              </div>

              <div className="sbsabout_main_cont03">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    SBS 드라마는
                    <br /> ‘스튜디오S’의 출범과
                    <br />
                    함께 더욱 참신한 기획과
                    <br />
                    과감한 투자로 시청자들에게
                    <br />
                    웰메이드 작품을 선사합니다.
                  </p>
                </div>
              </div>

              <div className="sbsabout_main_cont04">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    SBS 교양은 색다른 연출과
                    <br />
                    소재 선정으로 시청자들의
                    <br /> 신뢰를 받고, 시대정신을
                    <br /> 구현하기 위해 노력합니다.
                  </p>
                </div>
              </div>

              <div className="sbsabout_main_cont05">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    SBS 뉴스는 단순한 <br />
                    정보 전달을 뛰어넘어
                    <br /> 현안을 심층 분석하고
                    <br />
                    시대의 어젠다를 제시하는
                    <br />
                    ‘한 단계 진화된 뉴스’를
                    <br /> 선보입니다.
                  </p>
                </div>
              </div>

              <div className="sbsabout_main_cont06">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    SBS 라디오는 음악과
                    <br /> 이야기를 통한 적극적인
                    <br /> 교감으로 단단한 애청자 층을 만들어 나갑니다.
                  </p>
                </div>
              </div>

              {/* <!-- 프로그램 --> */}
              <div className="sbsabout_main_program">
                <div className="sbsabout_inner">
                  <h4 className="module_title_w">
                    <a className="module_title_link" href="/m/program">
                      <span className="module_title_text">대표 프로그램</span>
                      <span className="svg_icon_arrow">
                        <svg width="9" height="15" viewBox="0 0 9 15">
                          <path
                            d="M7.5,6.287,13.175.33a1.032,1.032,0,0,1,1.514,0,1.175,1.175,0,0,1,0,1.593L8.262,8.672a1.034,1.034,0,0,1-1.478.033L.313,1.928A1.154,1.154,0,0,1,0,1.132a1.154,1.154,0,0,1,.313-.8,1.032,1.032,0,0,1,1.514,0Z"
                            transform="translate(0 15) rotate(-90)"
                            fill="#fff"
                          />
                        </svg>
                      </span>
                    </a>
                  </h4>
                  <div className="module_poster_list_w">
                    <div className="module_poster_list_swipe">
                      <div
                        className="module_poster_list"
                        style={sectionStyle}
                        onTouchMove={(e) => posterTouch(e)}
                      >
                        <ul className="module_poster_list_inner">
                          {bestProgramViewData.map((item, index) => {
                            return (
                              <li
                                key={index}
                                className="module_poster_list_cont"
                              >
                                <div className="post_box_w">
                                  <a
                                    href={item.link_url}
                                    className="pb_link"
                                    title={
                                      item.title + " sbsplay 사이트로 이동"
                                    }
                                  >
                                    <div className="pb_image_w">
                                      <div className="pb_image_inner">
                                        <img
                                          src={item.img_url}
                                          className="pb_image"
                                          alt={item.title}
                                        />
                                      </div>
                                    </div>
                                    <div className="pb_info_w">
                                      <span className="pbif_title">
                                        {item.title}
                                      </span>
                                    </div>
                                  </a>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {/* 페이지네이션 Dot 및 이전/다음 버튼 */}
                      <span className="hide">
                        전체 {bestProgramMaxPageCount}개의 리스트 중{" "}
                        {bestProgram + 1}
                      </span>
                      {bestProgramMaxPageCount > 1 && (
                        <div className="slide_btns_w">
                          <div className="slide_btns_inner">
                            <ul
                              className="slide_dots_w"
                              style={{
                                position: "static",
                                textAlign: "center",
                              }}
                            >
                              {[...Array(bestProgramMaxPageCount)].map(
                                (_, index) => (
                                  <li
                                    key={index}
                                    className={`slide_dots ${
                                      bestProgram === index ? "current" : ""
                                    }`}
                                    style={{
                                      display: "inline-block",
                                      float: "none",
                                    }} // 스타일 조절
                                  >
                                    <a
                                      href="#none"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setBestProgram(index);
                                      }}
                                      aria-label={`${index + 1}번째 페이지`}
                                      className="slide_link"
                                    ></a>
                                  </li>
                                )
                              )}
                            </ul>

                            <button
                              type="button"
                              className={`slide_arrow_prev ${
                                bestProgram === 0 ? "disable" : ""
                              }`}
                              onClick={handlePrevBestProgram}
                              style={{
                                zIndex: 99999,
                              }}
                            >
                              <i className="hide">이전 목록</i>
                            </button>
                            <button
                              type="button"
                              className={`slide_arrow_next ${
                                bestProgram >= bestProgramMaxPageCount - 1
                                  ? "disable"
                                  : ""
                              }`}
                              onClick={handleNextBestProgram}
                              style={{
                                zIndex: 99999,
                              }}
                            >
                              <i className="hide">다음 목록</i>
                              {/* 아이콘 추가 필요시 여기에 SVG 또는 아이콘 폰트 추가 */}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- 플랫폼소개 --> */}
              <div className="sbsabout_main_platform">
                <div className="sbsabout_inner">
                  <h4 className="module_title_w">
                    <a className="module_title_link" href="/m/platform">
                      <span className="module_title_text">플랫폼 소개</span>
                      <span className="svg_icon_arrow">
                        <svg width="9" height="15" viewBox="0 0 9 15">
                          <path
                            d="M13.69,17.533l5.672-5.957a1.032,1.032,0,0,1,1.514,0,1.175,1.175,0,0,1,0,1.593L14.45,19.919a1.034,1.034,0,0,1-1.478.033L6.5,13.175a1.171,1.171,0,0,1,0-1.593,1.032,1.032,0,0,1,1.514,0Z"
                            transform="translate(-11.246 21.188) rotate(-90)"
                            fill="#333"
                          />
                        </svg>
                      </span>
                    </a>
                  </h4>
                  <div className="platform_list_w">
                    <ul className="platform_list_inner">
                      <li className="platform_list_cont">
                        <a
                          className="platform_list_link"
                          href="https://www.sbs.co.kr/"
                        >
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/sbs_web.png"
                                alt="sbs web"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">sbs.co.kr</strong>
                            <span className="pt_value">WEBSITE</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href={
                            isIOS
                              ? "https://apps.apple.com/kr/app/sbs-%EC%98%A8%EC%97%90%EC%96%B4-%EC%A0%9C%EA%B3%B5-vod-7%EB%A7%8C%ED%8E%B8-%EC%A0%9C%EA%B3%B5/id1020136055"
                              : "https://play.google.com/store/apps/details?id=kr.co.sbs.videoplayer"
                          }
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_logo_w">
                            <img
                              src="../styles/2022/m/img/sbs_app_icon.png"
                              alt="sbs아이콘"
                              className="logo_image"
                            />
                          </div>
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/sbs_app.png"
                                alt="sbs app"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">SBS play</strong>
                            <span className="pt_value">App</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href={
                            isIOS
                              ? "https://apps.apple.com/us/app/sbs-%EA%B3%A0%EB%A6%B4%EB%9D%BC/id406456433"
                              : "https://play.google.com/store/apps/details?id=com.appgate.gorealra"
                          }
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_logo_w">
                            <img
                              src="../styles/2022/m/img/goreala_app_icon.png"
                              alt="고릴라앱 아이콘"
                              className="logo_image"
                            />
                          </div>
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/goreala_app.png"
                                alt="고릴라앱"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">SBS 고릴라</strong>
                            <span className="pt_value">App</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href={
                            isIOS
                              ? "https://apps.apple.com/kr/app/sbsnews/id371932445"
                              : "https://play.google.com/store/apps/details?id=com.cubeflux.news&hl=ko&gl=US"
                          }
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_logo_w">
                            <img
                              src="../styles/2022/m/img/sbsnews_app_icon.png"
                              alt="SBS뉴스 앱 아이콘"
                              className="logo_image"
                            />
                          </div>
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/sbsnews_app.png"
                                alt="sbs뉴스앱"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">SBS NEWS</strong>
                            <span className="pt_value">App</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href={
                            isIOS
                              ? "https://apps.apple.com/kr/app/sbs%EA%B3%A8%ED%94%84/id450445233"
                              : "https://play.google.com/store/apps/details?id=com.confitech.sbsgolf&hl=ko&gl=US"
                          }
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_logo_w">
                            <img
                              src="../styles/2022/m/img/sbsgolf_app_icon.png"
                              alt="sbs골프 앱 아이콘"
                              className="logo_image"
                            />
                          </div>
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/sbsgolf_app.png"
                                alt="sbs골프"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">SBS 골프</strong>
                            <span className="pt_value">App</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href={
                            isIOS
                              ? "https://apps.apple.com/kr/app/sbs-biz/id425106890"
                              : "https://play.google.com/store/apps/details?id=kr.co.sbs.cnbc&hl=ko&gl=US"
                          }
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_logo_w">
                            <img
                              src="../styles/2022/m/img/sbsbiz_app_icon.png"
                              alt="sbs biz 앱 아이콘"
                              className="logo_image"
                            />
                          </div>
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/sbsbiz_app.png"
                                alt="sbs biz 앱"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">SBS Biz</strong>
                            <span className="pt_value">App</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href="https://allvod.sbs.co.kr/allvod/vodMain.do?div=gnb_pc"
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/allvod_web.png"
                                alt="allvod 앱"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">ALLVOD</strong>
                            <span className="pt_value">WEBSITE</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">ALL VOD</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="platform_list_cont">
                        <a
                          href="https://star.sbs.co.kr/"
                          className="platform_list_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="새 창 열림"
                        >
                          <div className="platform_image_w">
                            <div className="platform_image_inner">
                              <img
                                src="../styles/2022/m/img/star_web.png"
                                alt="star 웹"
                                className="platform_image"
                              />
                            </div>
                          </div>
                          <div className="platform_text_w">
                            <strong className="pt_title">STAR</strong>
                            <span className="pt_value">WEBSITE</span>
                            <span className="pt_round">
                              <span className="pt_arrow">
                                <svg width="10" height="6" viewBox="0 0 10 6">
                                  <path
                                    d="M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z"
                                    transform="translate(1 1)"
                                    fill="#fff"
                                  />
                                </svg>
                                <i className="hide">페이지 이동</i>
                              </span>
                            </span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* <!-- 최신소식 --> */}
              <div className="sbsabout_main_update">
                <div className="sbsabout_inner">
                  <h4 className="module_title_w">
                    <a href="/m/report" className="module_title_link">
                      <span className="module_title_text">최신 소식</span>
                      <span className="svg_icon_arrow">
                        <svg width="9" height="15" viewBox="0 0 9 15">
                          <path
                            d="M13.69,17.533l5.672-5.957a1.032,1.032,0,0,1,1.514,0,1.175,1.175,0,0,1,0,1.593L14.45,19.919a1.034,1.034,0,0,1-1.478.033L6.5,13.175a1.171,1.171,0,0,1,0-1.593,1.032,1.032,0,0,1,1.514,0Z"
                            transform="translate(-11.246 21.188) rotate(-90)"
                            fill="#333"
                          />
                        </svg>
                      </span>
                    </a>
                  </h4>

                  <div className="update_list_w02">
                    <div className="module_thumb_list">
                      <ul className="module_thumb_list_inner">
                        {recentNewsViewData.map((item, index) => {
                          // recentNewsViewData 사용
                          return (
                            <li key={index} className="module_thumb_list_cont">
                              <div className="module_box_w_type3">
                                <a
                                  href={item.link_url || "#"}
                                  className="mb_link"
                                  target={
                                    item.link_url &&
                                    item.link_url.startsWith("http")
                                      ? "_blank"
                                      : "_self"
                                  }
                                  rel="noopener noreferrer"
                                >
                                  <div className="mb_image_w">
                                    <div className="mb_image_inner">
                                      <img
                                        src={
                                          item.img_url ||
                                          "../styles/2022/m/img/no_img.png"
                                        } // 이미지 URL 없을 경우 대비
                                        className="mb_image"
                                        alt={item.title || "뉴스 이미지"} // alt 텍스트 없을 경우 대비
                                        onError={(e) => {
                                          // 이미지 로딩 실패 시 대체 이미지
                                          e.target.onerror = null;
                                          e.target.src =
                                            "../styles/2022/m/img/no_img.png";
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb_info_w">
                                    <span className="mbif_title">
                                      {item.title}
                                    </span>
                                    <div className="mb_infoline_inner">
                                      <span className="mbif_update">
                                        등록일
                                      </span>
                                      <span className="mbif_date">
                                        {item.reg_date
                                          ? moment(item.reg_date).format(
                                              "YYYY.MM.DD"
                                            )
                                          : "-"}
                                      </span>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    {recentNewsMaxPageCount > 1 && ( // 페이지가 2개 이상일 때만 표시
                      <div className="slide_btns_w">
                        <div className="slide_btns_inner">
                          <ul className="slide_dots_w">
                            {[...Array(recentNewsMaxPageCount)].map(
                              (_, index) => (
                                <li
                                  key={index}
                                  className={`slide_dots ${
                                    recentNews === index ? "current" : ""
                                  }`}
                                >
                                  <a
                                    className="slide_link"
                                    onClick={() => setRecentNews(index)}
                                    aria-label={`페이지 ${index + 1}로 이동`}
                                    href="#none" // href 추가하여 링크 역할 명시
                                  >
                                    <span style={{ display: "none" }}>
                                      {index + 1}
                                    </span>
                                  </a>
                                </li>
                              )
                            )}
                          </ul>

                          <button
                            type="button"
                            className={`slide_arrow_prev ${
                              recentNews === 0 ? "disable" : ""
                            }`}
                            onClick={handlePrevNews}
                            disabled={recentNews === 0} // 첫 페이지일 때 비활성화
                            style={{ zIndex: 99999 }} // z-index 추가하여 클릭 영역 확보
                          >
                            <i className="hide">이전 목록</i>
                          </button>
                          <button
                            type="button"
                            className={`slide_arrow_next ${
                              recentNews >= recentNewsMaxPageCount - 1
                                ? "disable"
                                : ""
                            }`}
                            onClick={handleNextNews}
                            disabled={recentNews >= recentNewsMaxPageCount - 1} // 마지막 페이지일 때 비활성화
                            style={{ zIndex: 99999 }} // z-index 추가하여 클릭 영역 확보
                          >
                            <i className="hide">다음 목록</i>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="sbsabout_main_cont07">
                <div className="sbsabout_inner">
                  <p className="smc_text">
                    SBS는 한계를 뛰어넘는 도전으로
                    <br />
                    방송산업의 패러다임을 주도하는
                    <br />
                    No.1 콘텐츠 기업으로 나아갈 것입니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MainBottom />
      </div>
    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default Home;
